import { useEffect } from "react";
import { useYizheJump } from "@/hooks/useYizheJump";

/**
 * 打印事件处理 监听全局打印事件 跳转衣者打印系统
 */
const YizhePrintEventHandler: React.FC = () => {
  const { handleYizheJump } = useYizheJump();

  useEffect(() => {
    const handlePrintEvent = () => {
      handleYizheJump();
    };
    // 监听全局打印事件
    window.addEventListener("triggerPrintJump", handlePrintEvent);
    return () => {
      window.removeEventListener("triggerPrintJump", handlePrintEvent);
    };
  }, [handleYizheJump]);
  // 这个组件不需要渲染任何UI
  return null;
};

export default YizhePrintEventHandler;
